import { Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Check, Clear } from '@mui/icons-material';

type ConfirmDialogProps = {
    open: boolean;
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    confirmColor?: ButtonProps['color'];
    cancelColor?: ButtonProps['color'];
    onConfirm: () => void;
    onCancel: () => void;
};

export default function ConfirmDialog({
    open,
    title = 'Megerősítés',
    message,
    confirmText = 'Igen',
    cancelText = 'Nem',
    confirmColor = 'primary',
    cancelColor = 'warning',
    onConfirm,
    onCancel,
}: ConfirmDialogProps) {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>{title}</DialogTitle>

            <DialogContent>
                <Typography>{message}</Typography>
            </DialogContent>

            <DialogActions sx={{ justifyContent: 'space-between' }}>
                <Button sx={{ borderRadius: 50 }} variant='contained' color={cancelColor} startIcon={<Clear />} onClick={onCancel}>
                    {cancelText}
                </Button>
                <Button sx={{ borderRadius: 50 }} variant='contained' color={confirmColor} startIcon={<Check />} onClick={onConfirm}>
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
